function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useRef, useState } from 'react';
/**
 * Resolves the scrollable element inside the popover (the listbox, or the
 * container if the listbox isn't present) and attaches a scroll listener
 * to it. The listener is detached when the popover closes.
 */
export function useMultiSelectScrollListener(_ref) {
  var containerRef = _ref.containerRef,
    isOpen = _ref.isOpen,
    onScroll = _ref.onScroll;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    scrollAreaEl = _useState2[0],
    setScrollAreaEl = _useState2[1];

  // Mirror onScroll into a ref so the listener is attached once per
  // scrollAreaEl lifetime, regardless of caller memoization.
  var onScrollRef = useRef(onScroll);
  onScrollRef.current = onScroll;
  useEffect(() => {
    if (!isOpen) {
      setScrollAreaEl(null);
      return undefined;
    }

    // The ListBox mounts asynchronously inside the popover, so defer one
    // animation frame to give Spectrum time to attach.
    var handle = window.requestAnimationFrame(() => {
      var container = containerRef.current;
      if (container == null) {
        return;
      }
      var listBox = container.querySelector('[role="listbox"]');
      setScrollAreaEl(listBox !== null && listBox !== void 0 ? listBox : container);
    });
    return () => {
      window.cancelAnimationFrame(handle);
    };
  }, [isOpen, containerRef]);

  // Attach scroll listener when the scroll area becomes available.
  useEffect(() => {
    if (scrollAreaEl == null) {
      return undefined;
    }
    var handler = event => {
      onScrollRef.current(event);
    };
    scrollAreaEl.addEventListener('scroll', handler);
    return () => {
      scrollAreaEl.removeEventListener('scroll', handler);
    };
  }, [scrollAreaEl]);
}
export default useMultiSelectScrollListener;
//# sourceMappingURL=useMultiSelectScrollListener.js.map